/* AnimationPlayer组件样式 */
.animation-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.preview-content {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9; /* 使用标准的 16:9 比例自适应，彻底消除上下黑边 */
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  background-color: #000;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  color: var(--text-tertiary);
  text-align: center;
  flex: 1;
}

.empty-state i {
  font-size: 3rem;
  opacity: 0.5;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  text-align: center;
  flex: 1;
}

.loading-state .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(79, 109, 245, 0.3);
  border-top-color: var(--accent-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.error-state {
  background-color: rgba(255, 82, 82, 0.05);
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  text-align: center;
}

.error-state i {
  color: #ff5252;
  font-size: 2rem;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.rendering-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  flex: 1;
}

.rendering-state .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(79, 109, 245, 0.3);
  border-top-color: var(--accent-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.rendering-state p {
  color: var(--text-secondary);
  margin: 5px 0;
}

.render-tip {
  font-size: 0.8rem;
  color: var(--text-tertiary);
  margin-top: 10px;
}

.video-player {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
}

.preview-content.has-video {
  height: auto;
  min-height: 0;
  aspect-ratio: auto;
  background-color: transparent;
}

.preview-content.has-video .animation-container {
  height: auto;
  min-height: 0;
  background-color: transparent;
}

.video-frame {
  width: 100%;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  background-color: #000;
}

.animation-player .video-frame video {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  object-fit: contain;
  box-shadow: none;
  display: block;
}

.video-download-bar {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 0 8px;
  background: #0d0d0d;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.video-download-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  text-decoration: none;
  letter-spacing: 0.3px;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
  cursor: pointer;
}

.video-download-btn i {
  font-size: 15px;
}

.video-download-btn:hover {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.render-error {
  background-color: rgba(255, 82, 82, 0.1);
  border: 1px solid rgba(255, 82, 82, 0.3);
  color: #ff5252;
  padding: 20px;
  border-radius: 8px;
  margin: 15px;
  text-align: center;
}

.render-error i {
  display: block;
  font-size: 2.5rem;
}

.render-error h3 {
  font-size: 1.2rem;
  margin-bottom: 15px;
  color: #ff5252;
}

.render-error pre {
  text-align: left;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 12px;
  border-radius: 6px;
  overflow: auto;
  margin: 15px 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  white-space: pre-wrap;
  max-height: 200px;
}

.render-error-hint {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5;
}

.check-status-btn,
.test-server-btn,
.regenerate-btn {
  background-color: var(--accent-color);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  margin-top: 15px;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.check-status-btn:hover:not(:disabled),
.test-server-btn:hover:not(:disabled),
.regenerate-btn:hover:not(:disabled) {
  background-color: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 109, 245, 0.3);
}

.check-status-btn:disabled,
.test-server-btn:disabled,
.regenerate-btn:disabled {
  background-color: #888;
  cursor: not-allowed;
}

.check-status-btn i,
.test-server-btn i,
.regenerate-btn i {
  font-size: 1.1rem;
}

.server-status {
  margin-top: 15px;
  padding: 12px 15px;
  border-radius: 6px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.server-status i {
  font-size: 1.1rem;
}

.server-status.success {
  background-color: rgba(76, 175, 80, 0.1);
  border-left: 3px solid var(--success-color);
  color: var(--success-color);
}

.server-status.error {
  background-color: rgba(255, 82, 82, 0.1);
  border-left: 3px solid var(--error-color);
  color: var(--error-color);
}

.code-container {
  width: 100%;
}

.code-header {
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.code-block {
  padding: 20px;
  margin: 0;
  overflow: auto;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--text-primary);
  background-color: var(--dark-gray);
  max-height: 400px;
  white-space: pre;
}

/* 移动端响应式优化 */
@media (max-width: 768px) {
  .preview-content {
    min-height: 300px;
    padding: 0;
  }
  
  .empty-state,
  .loading-state {
    padding: 30px 15px;
  }
  
  .empty-state i,
  .loading-state .spinner {
    margin-bottom: 15px;
  }
  
  .check-status-btn,
  .test-server-btn,
  .regenerate-btn {
    width: 100%;
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
  
  .server-status {
    padding: 10px;
    font-size: 0.85rem;
  }
  
  .code-header {
    padding: 8px;
  }
  
  .code-block {
    padding: 15px;
    font-size: 0.85rem;
    max-height: 350px;
  }
}

@media (max-width: 480px) {
  .preview-content {
    min-height: 250px;
  }
  
  .rendering-state {
    padding: 20px;
  }
  
  .rendering-state .spinner {
    width: 30px;
    height: 30px;
    margin-bottom: 15px;
  }
  
  .render-error {
    padding: 15px;
    font-size: 0.85rem;
    margin: 10px;
  }
  
  .render-error i {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  
  .render-error h3 {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  
  .render-error pre {
    padding: 8px;
    font-size: 0.8rem;
    max-height: 150px;
  }
  
  .render-error-hint {
    font-size: 0.9rem;
  }
}
